export function schoolParams(schoolId: number) {
  return { school_id: schoolId };
}
